
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6313',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6313",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7924",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11370",
  "I18n": "static-7.1604",
  "jasmine-runner": "static-1.6379",
  "quartz": "static-1.6885",
  "quartz-core": "static-1.6104",
  "react-dlb": "static-1.77",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.771",
  "enviro": "static-4.428",
  "foundations-components": "static-1.7755",
  "history": "static-4.47",
  "hub-http": "static-1.6131",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11678",
  "icons": "static-2.639",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7070",
  "PortalIdParser": "static-2.388",
  "quartz-config": "static-1.663",
  "quartz-routing": "static-1.315",
  "quick-fetch": "static-1.3845",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16570",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5275",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18689",
  "signup-ui-lego-core": "static-1.20699",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "ui-addon-react-router-dom": "static-1.9456",
  "ui-images": "static-2.1131",
  "UIComponents": "static-3.8317",
  "usage-tracker": "static-1.7247",
  "usage-tracker-core": "static-1.7097",
  "viral-links-lib": "static-1.6959",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "bend-plugin-trellis-migration": "static-1.3334",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3162",
  "quartz-webpack": "static-1.3109",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3035",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "foundations-theming": "static-1.4326",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4235",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4581",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.560",
  "quartz-head": "static-1.550",
  "quartz-i18n": "static-1.560",
  "quartz-test": "static-1.560",
  "quartz-tracking": "static-1.264",
  "ui-fonts": "static-1.632",
  "usage-tracker-container": "static-1.7237",
  "sassPrefix": "static-1.154",
  "bend-plugin-foundations-components": "static-1.4024",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4762",
  "foundations-theming-specialty": "static-1.2042",
  "hs-story-utils": "static-1.9341",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1565",
  "hs-locale-management": "static-1.17",
  "superstore": "static-1.4680",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4556",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7943",
  "bender-build-tools": "static-1.3063",
  "bend-plugin-foundations-theming": "static-1.2809",
  "foundations-theming-base": "static-1.3311",
  "stylex": "static-1.30",
  "hub-http-shared-msw-handlers": "static-1.9758",
  "hubspotter-http-shared-msw-handlers": "static-1.9756",
  "usage-tracker-session-replay": "static-1.4933",
  "chirp-fetch": "static-1.1793",
  "ts-schema": "static-1.4007",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6313",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7924",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11370",
  "I18n": "/I18n/static-7.1604",
  "jasmine-runner": "/jasmine-runner/static-1.6379",
  "quartz": "/quartz/static-1.6885",
  "quartz-core": "/quartz-core/static-1.6104",
  "react-dlb": "/react-dlb/static-1.77",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.771",
  "enviro": "/enviro/static-4.428",
  "foundations-components": "/foundations-components/static-1.7755",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6131",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11678",
  "icons": "/icons/static-2.639",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7070",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "quartz-config": "/quartz-config/static-1.663",
  "quartz-routing": "/quartz-routing/static-1.315",
  "quick-fetch": "/quick-fetch/static-1.3845",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16570",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5275",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18689",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20699",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9456",
  "ui-images": "/ui-images/static-2.1131",
  "UIComponents": "/UIComponents/static-3.8317",
  "usage-tracker": "/usage-tracker/static-1.7247",
  "usage-tracker-core": "/usage-tracker-core/static-1.7097",
  "viral-links-lib": "/viral-links-lib/static-1.6959",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3334",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3162",
  "quartz-webpack": "/quartz-webpack/static-1.3109",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3035",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "foundations-theming": "/foundations-theming/static-1.4326",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4235",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4581",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.560",
  "quartz-head": "/quartz-head/static-1.550",
  "quartz-i18n": "/quartz-i18n/static-1.560",
  "quartz-test": "/quartz-test/static-1.560",
  "quartz-tracking": "/quartz-tracking/static-1.264",
  "ui-fonts": "/ui-fonts/static-1.632",
  "usage-tracker-container": "/usage-tracker-container/static-1.7237",
  "sassPrefix": "/sassPrefix/static-1.154",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4024",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4762",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2042",
  "hs-story-utils": "/hs-story-utils/static-1.9341",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1565",
  "hs-locale-management": "/hs-locale-management/static-1.17",
  "superstore": "/superstore/static-1.4680",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4556",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7943",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2809",
  "foundations-theming-base": "/foundations-theming-base/static-1.3311",
  "stylex": "/stylex/static-1.30",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9758",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9756",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4933",
  "chirp-fetch": "/chirp-fetch/static-1.1793",
  "ts-schema": "/ts-schema/static-1.4007",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
